// jk-favs.js — ЕДИНОЕ ИЗБРАННОЕ ЖК (блок A.5, команда владельца 31.07 «делай 1, 2 и 3»).
//
// ⛔ ЗАЧЕМ ОТДЕЛЬНЫЙ ФАЙЛ, А НЕ ЕЩЁ ОДНА ФУНКЦИЯ В utils.js.
// Разведка A.4 нашла в проекте ЧЕТЫРЕ независимых хранилища «избранного», а фикс-раунд
// добавил пятое (легаси «100 КВАДРАТОВ»). Четыре из пяти хранят ОДНУ И ТУ ЖЕ сущность —
// жилой комплекс:
//   • `favs`           — числа id ЖК; пишут карта каталога (catalog-map.js) и
//                        SEO-лендинги (catalog.js);
//   • `nv_favorites`   — числа id ЖК; пишет витрина «Жилищные комплексы» (novostrojki.js);
//   • `bronidom_favs`  — ОБЪЕКТЫ {id, name, district, area, deadline, price, color};
//                        пишет личный кабинет (cabinet.js);
//   • `kv100_favs`     — ОБЪЕКТЫ ЖК эпохи «100 КВАДРАТОВ»; cabinet.js читает фолбэком;
//   • `bronidom_flat_favs` — КВАРТИРЫ (flat.js / flat-overlay.js). ДРУГАЯ СУЩНОСТЬ,
//                        сюда не сводится и здесь не упоминается больше нигде.
// Из-за этого сердечко, поставленное на карте, на витрине не было видно, а счётчики
// двух страниц показывали разные числа. Свести их «по месту» нельзя: код миграции и
// правила слияния обязаны быть ОДНИ на все страницы, иначе через месяц у трёх копий
// разъедется нормализация id — ровно та болезнь, от которой A.4 лечил сердечки внутри
// одной страницы (`FavManager`), только масштабом в три страницы.
//
// ⛔ КЛЮЧ-ПОБЕДИТЕЛЬ — `favs`, И ЕГО ФОРМАТ МЕНЯТЬ НЕЛЬЗЯ (массив чисел id).
// Его уже пишут ДВЕ страницы, то есть он лежит в браузерах живых людей. Мы добавляем
// читателей и писателей, но не трогаем ни имя, ни форму значения.
//
// ⛔ ПОДКЛЮЧАТЬ ДО СТРАНИЧНЫХ СКРИПТОВ. В footer.php стоит сразу за utils.js, все теги
// `defer` ⇒ порядок исполнения гарантирован.
//
// ⛔ ВСЁ ХОЖДЕНИЕ В localStorage — В try/catch. Приватный режим Safari, отключённые
// куки и iframe с блокировкой сторонних данных бросают И на чтении, и на записи
// (`setItem` даёт QuotaExceededError даже на пустом хранилище). Непойманный бросок
// здесь убил бы страничный скрипт целиком — ровно тот прод-дефект, который A.4 вылечил
// в catalog-map.js, а этот блок доделывает в catalog.js.

(function () {
  'use strict';

  /** SSOT-ключ: массив ЧИСЕЛ — id жилых комплексов. */
  var KEY = 'favs';
  /** Витрина «Жилищные комплексы» до A.5. Тот же смысл, те же числа. Вливается и УДАЛЯЕТСЯ. */
  var LEGACY_IDS_KEY = 'nv_favorites';
  /**
   * Личный кабинет. Массив ОБЪЕКТОВ ЖК с оформлением карточки.
   *
   * ⛔ ЭТОТ КЛЮЧ ПОСЛЕ МИГРАЦИИ НЕ УДАЛЯЕТСЯ — И ЭТО ОСОЗНАННОЕ РЕШЕНИЕ, А НЕ НЕДОДЕЛКА.
   * Кабинет рисует из него имя, район, площадь, срок сдачи, цену и пару цветов градиента
   * (`renderFavs` в cabinet.js). Ни одного из этих полей в `favs` нет и быть не может —
   * там числа. Удалив ключ, мы получили бы в кабинете пустой список у человека, который
   * ничего не удалял. Поэтому роли разведены:
   *   • `favs`          — ЧЛЕНСТВО (кто в избранном) — единственный источник правды;
   *   • `bronidom_favs` — КЭШ ОФОРМЛЕНИЯ карточки для кабинета, ведомый.
   * Кабинет после A.5 отбрасывает при показе те объекты, чей id из `favs` уже убран
   * (сняли сердечко на карте), и пишет в `favs` при каждом своём добавлении/удалении.
   */
  var LEGACY_RICH_KEY = 'bronidom_favs';
  /**
   * ⛔ ЭПОХА «100 КВАДРАТОВ» — ДО-РЕБРЕНДИНГОВАЯ КОГОРТА. Тот же формат, что у
   * `bronidom_favs` (объекты ЖК), и `cabinet.js` до сих пор читает его ФОЛБЭКОМ:
   * `localStorage.getItem('bronidom_favs') || localStorage.getItem('kv100_favs')`.
   *
   * Пропустить его в слиянии было нельзя: у такого человека `favs` пуст, членство
   * пришло бы пустым, и фильтр кабинета вычистил бы ему весь список — ровно тот
   * сценарий, который комментарий у `LEGACY_RICH_KEY` объявляет недопустимым.
   */
  var LEGACY_KV100_KEY = 'kv100_favs';
  /**
   * Отметка «слияние уже выполнено».
   *
   * ⛔ БЕЗ НЕЁ МИГРАЦИЯ ВОСКРЕШАЛА БЫ СНЯТЫЕ СЕРДЕЧКИ. `bronidom_favs` мы не удаляем
   * (см. выше), поэтому «влить его при каждой загрузке» означало бы: человек снял
   * сердечко на карте → перезагрузил страницу → отметка вернулась из кэша кабинета.
   * Слияние — разовое событие перехода на единый ключ, а не постоянное правило.
   */
  var MERGED_FLAG = 'favs_merged_v1';

  /**
   * ⛔ ЗАПАСНАЯ ПАМЯТЬ НА СЛУЧАЙ НЕДОСТУПНОГО ХРАНИЛИЩА — НЕ УКРАШЕНИЕ, А ТРЕБОВАНИЕ.
   * В приватном режиме Safari и при отключённых куках обращение к `localStorage` бросает
   * САМО, ещё до чтения ключа. Модуль без этой копии отвечал бы «избранного нет» на
   * каждый вопрос, и человек видел бы, что сердечко не нажимается ВООБЩЕ — хуже, чем
   * «отметки не переживут перезагрузку». Правило A.4 дословно: «избранное тогда живёт до
   * перезагрузки, но карта работает». Копия — ведомая: пока хранилище живо, правда в нём.
   */
  var memory = [];
  var storageBroken = false;
  /** Слияние в недоступном хранилище пробуем один раз, а не на каждом чтении. */
  var migrateTried = false;

  function lsGet(key) {
    try { return localStorage.getItem(key); } catch (e) { storageBroken = true; return null; }
  }
  function lsSet(key, value) {
    try { localStorage.setItem(key, value); return true; } catch (e) { storageBroken = true; return false; }
  }
  function lsDel(key) {
    try { localStorage.removeItem(key); } catch (e) { /* приват-режим */ }
  }

  function parseArray(raw) {
    var arr;
    try { arr = JSON.parse(raw || '[]'); } catch (e) { return []; }
    return Array.isArray(arr) ? arr : [];
  }

  /**
   * Числовые id из массива ЛЮБОЙ из трёх исторических форм: число, строка, объект `{id}`.
   *
   * ⛔ НОРМАЛИЗАЦИЯ К ЧИСЛУ ОБЯЗАТЕЛЬНА. `catalog.js` кладёт то, что пришло из его
   * разметки (строки), карта сравнивает с числовым `item.id` из выдачи: без приведения
   * '22' и 22 — разные записи, и сердечко «теряется» между страницами. Мусор (NaN,
   * ноль, отрицательные, дубли) отбрасывается молча — иначе одна кривая запись из чужой
   * вкладки роняла бы избранное целиком.
   */
  function idsOf(arr) {
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var v = arr[i];
      if (v !== null && typeof v === 'object') v = v.id;
      var n = Number(v);
      if (!isFinite(n) || n <= 0 || out.indexOf(n) >= 0) continue;
      out.push(n);
    }
    return out;
  }

  function readKey(key) { return idsOf(parseArray(lsGet(key))); }

  /**
   * Разовое слияние старых хранилищ в `favs`.
   *
   * ⛔ ИДЕМПОТЕНТНОСТЬ ДЕРЖИТСЯ НА ДВУХ ВЕЩАХ СРАЗУ, И ОБЕ НУЖНЫ:
   *   1. слияние — ОБЪЕДИНЕНИЕ множеств, поэтому повторный проход не плодит дублей;
   *   2. флаг `favs_merged_v1` — потому что `bronidom_favs` остаётся жить, и без флага
   *      снятая отметка возвращалась бы из него при следующей загрузке.
   *
   * ⛔⛔ ПОРЯДОК ШАГОВ — ЭТО И ЕСТЬ ВСЯ БЕЗОПАСНОСТЬ МИГРАЦИИ. Нашёл верификатор:
   * прежняя редакция удаляла `nv_favorites` и ТОЛЬКО ПОТОМ писала флаг, не проверяя
   * результат. Квота, кончившаяся между этими двумя записями, давала худший из исходов:
   * источник уже уничтожен, а флага нет — и следующая загрузка сливала `bronidom_favs`
   * заново, ВОСКРЕШАЯ снятые человеком сердечки.
   *
   * Теперь порядок такой, и каждый шаг — только после УСПЕХА предыдущего:
   *   1. записать объединение в `favs`;
   *   2. перенести кэш оформления «100 КВАДРАТОВ» в текущий, если своего ещё нет;
   *   3. записать флаг «слияние выполнено» — он и есть гарантия однократности;
   *   4. и лишь теперь удалить старые ключи.
   * Провал на любом шаге оставляет ВСЕ источники нетронутыми: следующая загрузка
   * повторит слияние с тем же результатом, ничего не потеряв и никого не воскресив.
   *
   * ⚠️ ЧЕСТНОЕ ОГРАНИЧЕНИЕ. Пока квота переполнена НАСТОЛЬКО, что флаг записать нельзя,
   * однократность между загрузками не гарантирует никто: снятое сердечко вернётся при
   * следующем заходе. Persist-хранилища у нас в этот момент нет вообще, и придумать его
   * внутри модуля не из чего — сессия работает как «лучшее из возможного».
   *
   * @returns {boolean} было ли что-то влито (для тестов и отладки)
   */
  function migrate() {
    // Слияние в сессии ровно одно: память уже держит его результат — успешный или нет.
    if (migrateTried) return false;
    migrateTried = true;
    if (lsGet(MERGED_FLAG) === '1') return false;

    var ids = readKey(KEY);
    var before = ids.length;
    var extra = readKey(LEGACY_IDS_KEY)
      .concat(readKey(LEGACY_RICH_KEY))
      .concat(readKey(LEGACY_KV100_KEY));
    for (var i = 0; i < extra.length; i++) {
      if (ids.indexOf(extra[i]) < 0) ids.push(extra[i]);
    }

    if (!lsSet(KEY, JSON.stringify(ids))) {
      /**
       * ⛔ СЛИТЬ СМОГЛИ, ЗАПИСАТЬ — НЕТ (квота переполнена). Результат остаётся в
       * памяти: иначе человек с полной квотой видел бы в этой сессии ПУСТОЕ избранное,
       * хотя его отметки целы в старых ключах. Ничего не удаляем и флаг не ставим.
       */
      memory = ids;
      return false;
    }

    /**
     * ⛔ КЭШ ОФОРМЛЕНИЯ ПЕРЕЕЗЖАЕТ, А НЕ ВЫБРАСЫВАЕТСЯ. `kv100_favs` хранит те же
     * объекты ЖК, что и `bronidom_favs`, и кабинет читает его фолбэком. Удалить ключ,
     * влив только id, значило бы оставить до-ребрендинговую когорту без имён, районов
     * и цен в карточках — членство цело, а показать нечего. Переносим содержимое в
     * текущий ключ, но ТОЛЬКО если своего кэша ещё нет: чужими объектами затирать
     * актуальные нельзя.
     */
    var kv100 = lsGet(LEGACY_KV100_KEY);
    if (kv100 !== null && lsGet(LEGACY_RICH_KEY) === null) {
      if (!lsSet(LEGACY_RICH_KEY, kv100)) { memory = ids; return false; }
    }

    if (!lsSet(MERGED_FLAG, '1')) { memory = ids; return false; }

    lsDel(LEGACY_IDS_KEY);
    lsDel(LEGACY_KV100_KEY);
    return ids.length > before;
  }

  /**
   * Прочитать актуальный список. Первый вызов на странице выполняет слияние.
   *
   * ⛔ ЧИТАЕМ ИЗ ХРАНИЛИЩА КАЖДЫЙ РАЗ, А НЕ ИЗ ПАМЯТИ МОДУЛЯ. Копия в памяти устарела бы
   * ровно в том сценарии, ради которого блок и делается: две вкладки сайта открыты
   * одновременно, и вторая уже дописала в тот же ключ.
   */
  function read() {
    /**
     * ⛔ ПРИЗНАК «ХРАНИЛИЩЕ СЛОМАНО» СБРАСЫВАЕТСЯ ПЕРЕД КАЖДОЙ ПОПЫТКОЙ (нашёл
     * верификатор). Прежде один-единственный бросок — например разовый
     * QuotaExceededError, когда человек в другой вкладке чистил кэш, — залипал до конца
     * жизни страницы: модуль НАВСЕГДА переставал читать хранилище и до перезагрузки
     * отвечал из памяти, не замечая ни чужих вкладок, ни того, что место освободилось.
     * Отказ localStorage бывает временным, и относиться к нему надо как к временному.
     */
    storageBroken = false;
    migrate();
    if (storageBroken) return memory.slice();
    var fresh = readKey(KEY);
    /**
     * ⛔ ПРОВЕРКА ПОВТОРЯЕТСЯ ПОСЛЕ ЧТЕНИЯ, А НЕ ТОЛЬКО ДО НЕГО. `migrate()` в этой
     * сессии срабатывает один раз и дальше выходит сразу, НЕ трогая хранилище, — то
     * есть первый флаг остаётся чистым, а бросает уже сам `readKey`. Без второй
     * проверки его пустой результат затирал бы память, и отметка, поставленная в
     * приватном режиме, пропадала бы на следующем же обращении.
     */
    if (storageBroken) return memory.slice();
    memory = fresh;
    return memory.slice();
  }

  /**
   * Положить готовый список в хранилище и вернуть то, что там оказалось.
   *
   * ⚠️ СЛИЯНИЯ ЗДЕСЬ НЕТ — И РАНЬШЕ КОММЕНТАРИЙ УТВЕРЖДАЛ ОБРАТНОЕ (правка верификатора).
   * Функция пишет РОВНО то, что ей дали. «Читай-сливай-пиши» реализуют `add` и `remove`:
   * они берут свежий список из хранилища через `read()` и меняют в нём ОДИН id. Разница
   * важна для того, кто будет звать `write` из нового места: передав сюда копию из
   * памяти страницы, он затрёт отметки соседней вкладки — то есть вернёт ровно ту
   * болезнь, ради которой блок и делался.
   */
  function write(ids) {
    memory = idsOf(ids);
    // Запись не прошла (приват-режим / квота) — отдаём намерение из памяти, а не пустоту
    // из недоступного хранилища: в пределах сессии сердечко обязано работать.
    if (!lsSet(KEY, JSON.stringify(memory))) return memory.slice();
    memory = readKey(KEY);
    return memory.slice();
  }

  function add(id) {
    var n = Number(id);
    if (!isFinite(n) || n <= 0) return read();
    var ids = read();
    if (ids.indexOf(n) < 0) ids.push(n);
    return write(ids);
  }

  function remove(id) {
    var n = Number(id);
    if (!isFinite(n) || n <= 0) return read();
    var ids = read();
    var idx = ids.indexOf(n);
    if (idx >= 0) ids.splice(idx, 1);
    return write(ids);
  }

  /**
   * ⛔ НАРУЖУ — ТОЛЬКО ГЛАГОЛЫ, НИ ОДНОГО ИМЕНИ КЛЮЧА (правка верификатора).
   * Прежний экспорт `KEY`/`LEGACY_*`/`MERGED_FLAG` был легальной дверью в обход SSOT:
   * имея имя ключа, любая страница могла написать `localStorage.setItem(JkFavs.KEY, …)`
   * своим форматом и мимо нормализации — то есть вернуть ровно ту рассинхронизацию,
   * которую блок закрывает. Ключи знает только этот файл.
   *
   * ⛔ `has()` и `count()` СНЯТЫ, а не оставлены «на будущее»: их никто не звал. Каждая
   * из них дёргала бы `read()` (то есть поход в хранилище) на каждый вопрос, тогда как
   * страницы держат список в памяти и отвечают из него. Мёртвый метод в публичном API
   * — приглашение позвать его в цикле отрисовки.
   */
  window.JkFavs = {
    migrate: migrate,
    read: read,
    add: add,
    remove: remove,
    /** @returns {{ids: number[], on: boolean}} новый список и итоговое состояние этого id. */
    toggle: function (id) {
      var n = Number(id);
      if (!isFinite(n) || n <= 0) return { ids: read(), on: false };
      var on = read().indexOf(n) < 0;
      return { ids: on ? add(n) : remove(n), on: on };
    }
  };
})();
